import { render, staticRenderFns } from "./benefit-form-modal.vue?vue&type=template&id=3b93b510&"
import script from "./benefit-form-modal.vue?vue&type=script&lang=js&"
export * from "./benefit-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports